import MenuHideIcon from "assets/images/contract-left-line.png";
import ExpandMenuIcon from "assets/images/expand-menu.png";
import HomeIcon from "assets/images/home.svg";
import LeadcareIcon from "assets/images/lead-care-icon.svg";
import { ReactComponent as MiniLogo } from "assets/images/logo.svg";
import { ReactComponent as MobileLogo } from "assets/images/mobilelogo.svg";
import OutreachStafIcon from "assets/images/outreach-staf-icon.svg";
import OutreactLeaderIcon from "assets/images/outreact-leader-icon.svg";
import QuestionIcon from "assets/images/question.svg";
import ReleaseIcon from "assets/images/release.svg";
import CommunityOutreachIcon from "assets/images/community.svg";
import MenuShowIcon from "assets/images/sidebarshow-icon.svg";
import UserIcon from "assets/images/user.svg";
import SubTitle from "assets/images/subtitles.svg";
import UsersIcon from "assets/images/users.svg";
import ReferralIcon from "assets/images/Frame.svg";
import classNames from "classnames";
import LatestRelease from "components/release/LatestRelease";
import { LOGIN_ROLES } from "constants/common";
import {
  DASHBOARD_PATH,
  Leadcaremanager_PATH,
  Members_PATH,
  OutreachLeaders_PATH,
  OutreachStaff_PATH,
  POLICIES_PATH,
  COMMUNITY_OUTREACH_PATH,
  QUESTIONS_PATH,
  RELEASE_PATH,
  SURVEY_HISTORIES_PATH,
  REFERRALS_PATH,
  USERS_PATH,
  TEMPLATES_PATH,
  SPA_PATH,
} from "constants/routePaths";
import { Notepad, UserList } from "phosphor-react";
import React, { useState } from "react";
import { Accordion, Offcanvas } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { getUserInfo } from "utils/common";
import "./sidebar.scss";

const Sidebar = () => {
  const [showLabels, setShowLabel] = useState(true);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const toggleSidebarStyle = () => setShowLabel((pre) => !pre);

  const routes =
    getUserInfo()?.type === LOGIN_ROLES.outreachleader &&
    getUserInfo()?.super_admin
      ? [
          {
            path: DASHBOARD_PATH,
            icon: (
              <img
                src={HomeIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Dashboard",
          },
          {
            path: Members_PATH,
            icon: (
              <img
                src={UserIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Members",
          },
          {
            path: COMMUNITY_OUTREACH_PATH,
            icon: (
              <img
                src={CommunityOutreachIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Community Engagement",
          },
          {
            path: REFERRALS_PATH,
            icon: (
              <img
                src={ReferralIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Referrals",
          },
          {
            path: Leadcaremanager_PATH,
            icon: (
              <img
                src={LeadcareIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Care Managers",
          },
          {
            path: POLICIES_PATH,
            icon: <Notepad size={32} />,
            label: "Policies",
          },
          {
            path: SURVEY_HISTORIES_PATH,
            icon: <UserList size={24} />,
            label: "History",
          },
          {
            path: TEMPLATES_PATH,
            icon: (
              <img
                src={SubTitle}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Templates & Questions",
          },

          {
            path: USERS_PATH,
            icon: (
              <img
                src={UsersIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Users",
          },
          {
            path: RELEASE_PATH,
            icon: (
              <img
                src={ReleaseIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Releases",
          },
          {
            path: SPA_PATH,
            icon: (
              <img
                src={ReleaseIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "SPA",
          },
          // {
          //   path: QUESTIONS_PATH,
          //   icon: (
          //     <img
          //       src={QuestionIcon}
          //       className="my-img-svg "
          //       width={26}
          //       alt="icon"
          //     />
          //   ),
          //   label: "Questions",
          // },
          // {
          //   path: OutreachLeaders_PATH,
          //   icon: (
          //     <img
          //       src={OutreactLeaderIcon}
          //       className="my-img-svg "
          //       width={26}
          //       alt="icon"
          //       fill="red"
          //     />
          //   ),
          //   label: "Outreach Leaders",
          // },
          // {
          //   path: OutreachStaff_PATH,
          //   icon: (
          //     <img
          //       src={OutreachStafIcon}
          //       className="my-img-svg "
          //       width={26}
          //       alt="icon"
          //     />
          //   ),
          //   label: "Outreach Staff",
          // },
        ]
      : getUserInfo()?.type === LOGIN_ROLES.outreachleader
      ? [
          {
            path: DASHBOARD_PATH,
            icon: (
              <img
                src={HomeIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Dashboard",
          },
          {
            path: Members_PATH,
            icon: (
              <img
                src={UserIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Members",
          },
          {
            path: COMMUNITY_OUTREACH_PATH,
            icon: (
              <img
                src={CommunityOutreachIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Community Engagement",
          },
          {
            path: REFERRALS_PATH,
            icon: (
              <img
                src={ReferralIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Referrals",
          },
          {
            path: Leadcaremanager_PATH,
            icon: (
              <img
                src={LeadcareIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Care Managers",
          },
          // {
          //   path: OutreachLeaders_PATH,
          //   icon: (
          //     <img
          //       src={OutreactLeaderIcon}
          //       className="my-img-svg "
          //       width={26}
          //       alt="icon"
          //       fill="red"
          //     />
          //   ),
          //   label: "Outreach Leaders",
          // },
          // {
          //   path: OutreachStaff_PATH,
          //   icon: (
          //     <img
          //       src={OutreachStafIcon}
          //       className="my-img-svg "
          //       width={26}
          //       alt="icon"
          //     />
          //   ),
          //   label: "Outreach Staff",
          // },
          {
            path: POLICIES_PATH,
            icon: <Notepad size={32} />,
            label: "Policies",
          },

          {
            path: SURVEY_HISTORIES_PATH,
            icon: <UserList size={24} />,
            label: "History",
          },
          // {
          //   path: TEMPLATES_PATH,
          //   icon: (
          //     <img
          //       src={SubTitle}
          //       className="my-img-svg "
          //       width={26}
          //       alt="icon"
          //     />
          //   ),
          //   label: "Templates & Questions",
          // },
          {
            path: USERS_PATH,
            icon: (
              <img
                src={UsersIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Users",
          },
        ]
      : getUserInfo()?.type === LOGIN_ROLES.outreachleader
      ? [
          {
            path: DASHBOARD_PATH,
            icon: (
              <img
                src={HomeIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Dashboard",
          },
          {
            path: Members_PATH,
            icon: (
              <img
                src={UserIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Members",
          },
          {
            path: COMMUNITY_OUTREACH_PATH,
            icon: (
              <img
                src={CommunityOutreachIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Community Engagement",
          },
          {
            path: REFERRALS_PATH,
            icon: (
              <img
                src={ReferralIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Referrals",
          },
          {
            path: Leadcaremanager_PATH,
            icon: (
              <img
                src={LeadcareIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Care Managers",
          },
          // {
          //   path: OutreachLeaders_PATH,
          //   icon: (
          //     <img
          //       src={OutreactLeaderIcon}
          //       className="my-img-svg "
          //       width={26}
          //       alt="icon"
          //       fill="red"
          //     />
          //   ),
          //   label: "Outreach Leaders",
          // },
          // {
          //   path: OutreachStaff_PATH,
          //   icon: (
          //     <img
          //       src={OutreachStafIcon}
          //       className="my-img-svg "
          //       width={26}
          //       alt="icon"
          //     />
          //   ),
          //   label: "Outreach Staff",
          // },
          {
            path: POLICIES_PATH,
            icon: <Notepad size={32} />,
            label: "Policies",
          },
          {
            path: SURVEY_HISTORIES_PATH,
            icon: <UserList size={24} />,
            label: "History",
          },
          // {
          //   path: TEMPLATES_PATH,
          //   icon: (
          //     <img
          //       src={SubTitle}
          //       className="my-img-svg "
          //       width={26}
          //       alt="icon"
          //     />
          //   ),
          //   label: "Templates & Questions",
          // },
          {
            path: USERS_PATH,
            icon: (
              <img
                src={UsersIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Users",
          },
        ]
      : getUserInfo()?.type === LOGIN_ROLES.outreachstaff
      ? [
          {
            path: DASHBOARD_PATH,
            icon: (
              <img
                src={HomeIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Dashboard",
          },
          {
            path: Members_PATH,
            icon: (
              <img
                src={UserIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Members",
          },
          {
            path: COMMUNITY_OUTREACH_PATH,
            icon: (
              <img
                src={CommunityOutreachIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Community Engagement",
          },
          {
            path: REFERRALS_PATH,
            icon: (
              <img
                src={ReferralIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Referrals",
          },
          {
            path: SURVEY_HISTORIES_PATH,
            icon: <UserList size={24} />,
            label: "History",
          },
          // {
          //   path: USERS_PATH,
          //   icon: (
          //     <img
          //       src={UsersIcon}
          //       className="my-img-svg "
          //       width={26}
          //       alt="icon"
          //     />
          //   ),
          //   label: "Users",
          // },
          // {
          //   path: TEMPLATES_PATH,
          //   icon: (
          //     <img
          //       src={SubTitle}
          //       className="my-img-svg "
          //       width={26}
          //       alt="icon"
          //     />
          //   ),
          //   label: "Templates",
          // }
        ]
      : getUserInfo()?.type === LOGIN_ROLES.referralcoordinator
      ? [
          {
            path: COMMUNITY_OUTREACH_PATH,
            icon: (
              <img
                src={CommunityOutreachIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Community Engagement",
          },
          {
            path: REFERRALS_PATH,
            icon: (
              <img
                src={ReferralIcon}
                className="my-img-svg "
                width={26}
                alt="icon"
              />
            ),
            label: "Referrals",
          },
          {
            path: SURVEY_HISTORIES_PATH,
            icon: <UserList size={24} />,
            label: "History",
          },
        ]
      : [];
  const renderLinks = (showLabels) => {
    return routes.map((route, index) => (
      <NavLink to={route.path} key={index} onClick={handleClose}>
        <p className="menu-linkk">
          {React.cloneElement(route.icon)}
          {showLabels && <span className="heading-smb">{route.label}</span>}
        </p>
      </NavLink>
    ));
  };
  const navMain = (
    <>
      <div className="logo-menu-otr">
        <div className="logo-otr">
          <MiniLogo />
        </div>
        <div className="menu-icon-otr" onClick={toggleSidebarStyle}>
          <img src={MenuHideIcon} alt="icon" />
        </div>
      </div>
      <Accordion defaultActiveKey="4">
        {renderLinks(showLabels)}{" "}
        {/* Render links dynamically using the renderLinks function */}
      </Accordion>
    </>
  );

  const navMini = (
    <>
      {/* <div className="menu-icon-otr" onClick={toggleSidebarStyle}>
        <img src={MenuHideIcon} alt="icon" />
      </div> */}
      <div className="logo-menu-otr">
        <div className="logo-otr">
          <p className="showsidebar-header">
            <MobileLogo style={{ marginLeft: "15px" }} />
          </p>
        </div>
      </div>
      <Accordion defaultActiveKey="4">
        {renderLinks(showLabels)}{" "}
        {/* Render links dynamically using the renderLinks function */}
      </Accordion>
    </>
  );

  const navMobile = (
    <>
      <div
        className="show-sidebar-icon"
        onClick={handleShow}
        style={{ width: "max-content" }}
      >
        <img className="logo-space" src={MenuShowIcon} alt="icon" />
        {/* <p className="showsidebar-header pt-3 ps-2">
          <MobileLogo />
        </p> */}
      </div>
      <Offcanvas show={show} onHide={handleClose} className="sidebar-offcanvas">
        <Offcanvas.Header closeButton>
          <span></span>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className={`App sidebar-main`}>
            <Accordion defaultActiveKey="4">{renderLinks(true)}</Accordion>
            <div className="bottom-left p-3">
              {<LatestRelease minified={false} withToolTip={false} />}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );

  return (
    <>
      {navMobile}
      {!showLabels && (
        <div className="menu-icon-otr-1" onClick={toggleSidebarStyle}>
          <img src={ExpandMenuIcon} alt="icon" width={24} />
        </div>
      )}
      <div
        className={classNames("App sidebar-main hide-side-nav", {
          "sidebar-mini": !showLabels,
        })}
      >
        {showLabels ? navMain : navMini}
        <div className="bottom-left p-2">
          {<LatestRelease minified={!showLabels} />}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
